import React, {Component, Fragment} from "react";
import SimpleCheckBox from "../../../../../../modules/SimpleCheckBox";
import SimpleDDL from "../../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../../modules/simpleTextArea";
import SimpleButton from "../../../../../../modules/commons/SimpleButton";
import FlexView from "react-flexview";
import ErrorAction from "../../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {contructQueryParam, fetchDataAsync} from "../../../../../../Services/Utils";
import Api from "../../../../../../Services/Api";
import {ACTIVITY_TYPE, HttpStatus, Status} from "../../../../../common/Constants";
import {mapToObjectDDL} from "../../../../../common/mapper";
import SimpleLoadingOverlay from "../../../../../../modules/popup/SimpleLoadingOverlay";
import FakturJualDetailDataInput from "../fakturJualDetailDataInput";
import {config} from "../../config";
import * as R from "ramda";
import SimpleAlert from "../../../../../../modules/popup/SimpleAlert";

class TabDataPersonal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
            detailCustomerVisible: false,
            provinceOptions: [],
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            zipCodeOptions: [],
            hobbyOptions: [],
            interestOptions: [],
            religionOptions: [],
            jobOptions: [],
            genderOptions: [],
            isNIKNotfound: false,
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        const provinceOptions = [];
        const res = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllProvince,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: null,
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {
                    paramFilters: {
                        bizparCategory: "HOBBY_TYPE",
                        status: Status.ACTIVE,
                    },
                },
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {
                    paramFilters: {
                        bizparCategory: "INTEREST_TYPE",
                        status: Status.ACTIVE,
                    },
                },
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {
                    paramFilters: {
                        bizparCategory: "RELIGION_TYPE",
                        status: Status.ACTIVE,
                    },
                },
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {
                    paramFilters: {
                        bizparCategory: "JOB_TYPE",
                        status: Status.ACTIVE,
                    },
                },
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllBizpar,
                setError: this.props.setError,
                menuName: "Sales Order - Faktur Jual",
                args: {
                    paramFilters: {
                        bizparCategory: "GENDER_TYPE",
                        status: Status.ACTIVE,
                    },
                },
            }),
        ]);

        res.forEach((response, idx) => {
            if (idx === 0) {
                if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                    provinceOptions.push(...response.data.data.map(
                        d => mapToObjectDDL(d.provinceName, d.id))
                    )
                }
            }

            if (idx === 1) {
                if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                    this.setState((prevState) => ({
                        ...prevState,
                        hobbyOptions: response.data.data.map(
                            d => mapToObjectDDL(d.value, d.key)
                        ),
                    }))
                }
            }

            if (idx === 2) {
                if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                    this.setState((prevState) => ({
                        ...prevState,
                        interestOptions: response.data.data.map(
                            d => mapToObjectDDL(d.value, d.key)
                        ),
                    }))
                }
            }

            if (idx === 3) {
                if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                    this.setState((prevState) => ({
                        ...prevState,
                        religionOptions: response.data.data.map(
                            d => mapToObjectDDL(d.value, d.key)
                        ),
                    }))
                }
            }

            if (idx === 4) {
                if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                    this.setState((prevState) => ({
                        ...prevState,
                        jobOptions: response.data.data.map(
                            d => mapToObjectDDL(d.value, d.key)
                        ),
                    }))
                }
            }

            if (idx === 5) {
                if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                    this.setState((prevState) => ({
                        ...prevState,
                        genderOptions: response.data.data.map(
                            d => mapToObjectDDL(d.value, d.key)
                        ),
                    }))
                }
            }
        });

        this.setState((prevState) => ({
            ...prevState,
            provinceOptions,
        }));

        this.handleTriggerLoading();
    }

    handleDetailCustomerVisible = () => {
        this.setState((prevState) => ({
            ...prevState,
            detailCustomerVisible: !prevState.detailCustomerVisible
        }))
    }

    getCheckMandatoryNIK = () => {
        const {tab} = this.props;
        return tab === "dataPembeli"
            ? !this.getValue("isCompany")
            : tab === "dataPemilik"
                ? !this.getValue("isBuyer")
                : !this.getValue("isMakelarProfessional") && this.getMandatoryField();
    }

    getCheckBoxName = () => {
        return this.props.tab === "dataPembeli"
            ? "isCompany"
            : this.props.tab === "dataPemilik"
                ? "isBuyer"
                : "isMakelarProfessional";
    }

    getCheckBoxLabel = () => {
        return this.props.tab === "dataPembeli"
            ? "Pembeli adalah Perusahaan / PT"
            : this.props.tab === "dataPemilik"
                ? "Pemilik adalah Pembeli"
                : "Makelar Profesional";
    }

    getNamaPersonal = () => {
        return this.props.tab === "dataPembeli"
            ? "Nama Pembeli"
            : this.props.tab === "dataPemilik"
                ? "Nama Pemilik"
                : "Nama Referral";
    }

    getValue = (key) => {
        const {tab} = this.props;
        return this.props.data?.[tab]?.[key] || null;
    }

    setReadOnlyNIK = () => {
        const {isEditable} = this.props.state;
        if(this.props.state.activityType === ACTIVITY_TYPE.UPDATE){
            return this.props.tab === "dataPemilik" ? false : !isEditable
        }
        if (isEditable) {
            return this.getValue(this.getCheckBoxName())
        }
        return true;
    }

    handleSelectCustomer = (value) => {
        const {tab} = this.props;
        this.setValueObject(tab, value)
        this.handleDetailCustomerVisible();
    }

    handleValueCheckBox = (name, value) => {
        const {tab} = this.props;
        this.setState((prevState) => ({
            ...prevState,
            isChecked: value,
        }))

        if (tab === "dataPemilik") {
            const {isCompany, ...filteredDataPemilik} = this.props.data?.["dataPembeli"];
            if (value) {
                this.setValueObject(tab, {isBuyer: true, ...filteredDataPemilik});
            } else {
                this.setValueObject(tab, {
                    isBuyer: false,
                    ...filteredDataPemilik,
                    name: null,
                    nik: null,
                    hpNumber1: null,
                    hpNumber2: null,
                    email: null,
                    address: null,
                    kkNumber: null,
                    npwp: null,
                    province: null,
                    kabkot: null,
                    kecamatan: null,
                    kelurahan: null,
                    zipCode: null,
                    gender: null,
                    job1: null,
                    job2: null,
                    religion: null,
                    memberId: null,
                    memberLevel: null,
                    loyaltyLevel: null,
                    facebook: null,
                    instagram: null,
                    linkedin: null,
                    x: null,
                    tiktok: null,
                    hobby: null,
                    interest: null,
                });
            }
            return;
        }

        if (tab === "dataPembeli" && value) {
            this.props.onSetState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    [tab]: {
                        ...prevState.data[tab],
                        [name]: value,
                        nik: null
                    }
                }
            }))
            return;
        }

        this.setValue(tab, name, value);
    }

    handleCheckNIK = async () => {
        this.handleTriggerLoading();
        const tab = this.props.tab;
        this.props.onSetState((prev) => ({
            ...prev,
            errors: {
                ...prev.errors,
                [tab]: {
                    ...prev.errors.tab,
                    nik: !this.getValue("nik") ? "Field belum diisi" : null,
                },
            },
        }));

        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").checkNIKSalesOrder,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: contructQueryParam({nik: this.getValue("nik")}),
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS && !R.isNil(res.data?.data)) {
            const {
                namaPembeli,
                province,
                kabkot,
                kecamatan,
                kelurahan,
                gender,
                religion,
                job1,
                job2,
                hobby,
                interest,
                ...filtered
            } = res.data?.data;
            this.setState((prev) => ({
                ...prev,
                isNIKNotfound: false,
            }));
            this.props.onSetState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    [tab]: {
                        ...prevState.data[tab],
                        ...filtered,
                        name: namaPembeli || null,
                        province: mapToObjectDDL(province?.provinceName, province?.id),
                        kabkot: mapToObjectDDL(kabkot?.kabKotName, kabkot?.kabKotId),
                        kecamatan: mapToObjectDDL(kecamatan?.kecamatanName, kecamatan?.id),
                        kelurahan: mapToObjectDDL(kelurahan?.kelurahanname, kelurahan?.id),
                        zipCode: mapToObjectDDL(filtered.zipCode, filtered.zipCode),
                        gender: mapToObjectDDL(gender?.value, gender?.key),
                        religion: mapToObjectDDL(religion?.value, religion?.key),
                        job1: mapToObjectDDL(job1?.value, job1?.key),
                        job2: mapToObjectDDL(job2?.value, job2?.key),
                        hobby: hobby?.length !== 0
                            ? hobby.map(item => mapToObjectDDL(item.value, item.key))
                            : null,
                        interest: interest?.length !== 0
                            ? interest.map(item => mapToObjectDDL(item.value, item.key))
                            : null,
                    }
                }
            }))
        }
        if (res.data.data === null) {
            this.setState((prev) => ({
                ...prev,
                isNIKNotfound: true,
            }));
        }
        this.handleTriggerLoading();
    }

    handleChangeProvince = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            kotaOptions: [],
            kecamatanOptions: [],
            kelurahanOptions: [],
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.setValue(tab, "kabkotId", null);
        this.setValue(tab, "kecamatanId", null);
        this.setValue(tab, "kelurahanId", null);
        this.setValue(tab, "zipCode", null);
        this.setValue(tab, name, value);
        if (value) {
            await this.fetchKotaOptions(value.value);
        }
    };

    handleChangeKota = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            kecamatanOptions: [],
            kelurahanOptions: [],
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.setValue(tab, "kecamatanId", null);
        this.setValue(tab, "kelurahanId", null);
        this.setValue(tab, "zipCode", null);
        this.setValue(tab, name, value);
        if (value) {
            await this.fetchKecamatanOptions(value.value);
        }
    };

    handleChangeKecamatan = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            kelurahanOptions: [],
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.setValue(tab, "kelurahanId", null);
        this.setValue(tab, "zipCode", null);
        this.setValue(tab, name, value);
        if (value) {
            await this.fetchKelurahanOptions(value.value);
        }
    };

    handleChangeKelurahan = async (name, value) => {
        this.setState((prevState) => ({
            ...prevState,
            zipCodeOptions: [],
        }));
        const {tab} = this.props;
        this.setValue(tab, "zipCode", null);
        this.setValue(tab, name, value);
        if (value) {
            await this.fetchZipCodeOptions(value.value);
        }
    };

    fetchKotaOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllCity,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kotaOptions: response.data.data.map((option) =>
                    mapToObjectDDL(option.kabKotName, option.kabKotId)
                ),
            }));
        }
    };

    fetchKecamatanOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKecamatan,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kecamatanOptions: response.data.data.map((option) =>
                    mapToObjectDDL(option.kecamatanName, option.id)
                ),
            }));
        }
    };

    fetchKelurahanOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllKelurahan,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                kelurahanOptions: response.data.data.map((option) => ({
                    ...mapToObjectDDL(option.kelurahanname, option.id),
                })),
            }));
        }
    };

    fetchZipCodeOptions = async (id) => {
        const response = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").getKelurahanById,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: id,
        });
        if (response.ok && response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
        if (response.ok) {
            this.setState((prevValue) => ({
                ...prevValue,
                zipCodeOptions: [mapToObjectDDL(response.data.data.zipcode, response.data.data.zipcode)],
            }));
        }
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    setValue = (tab, name, value) => {
        if (this.props.data.dataPemilik.isBuyer && tab === "dataPembeli") {
            this.props.onSetState((prevState) => ({
                ...prevState,
                data: {
                    ...prevState.data,
                    dataPemilik: {
                        ...prevState.data.dataPemilik,
                        [name]: value,
                    },
                },
            }));
        }
        if (
          tab === "dataPemilik" &&
          this.props.state.activityType === ACTIVITY_TYPE.UPDATE && name !== "isBuyer"
        ) {
          this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
              ...prevState.data,
              dataPemilik: {
                ...prevState.data[tab],
                isBuyer: false,
              },
            },
          }));
        }
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [tab]: {
                    ...prevState.data[tab],
                    [name]: value
                }
            }
        }))
    }

    setValueObject = (tab, value) => {
        this.props.onSetState((prevState) => ({
            ...prevState,
            data: {
                ...prevState.data,
                [tab]: {
                    ...prevState.data[tab],
                    ...value,
                }
            }
        }))
    }

    getMandatoryField = () => {
        const {tab} = this.props;
        const isReferal = tab !== "dataPembeli" && tab !== "dataPemilik";
        if (isReferal && this.getValue(this.getCheckBoxName())) {
            return true
        }
        return !isReferal;
    };

    checkIsReadOnly = () => {
        const {tab, state} = this.props;
        const {isEditable} = state ?? {};

        if (tab === 'dataPemilik') {
            const isCheckboxChecked = this.getValue?.(this.getCheckBoxName?.());
            return state.activityType === ACTIVITY_TYPE.UPDATE? false : !isEditable || isCheckboxChecked;
        }

        return !isEditable;
    }

    isCheckNIKDisabled = () => {
        const {state,tab} = this.props;
        if(this.props.state.activityType === ACTIVITY_TYPE.UPDATE){
            return tab === "dataPemilik" ? false : !state.isEditable
        }
        return this.setReadOnlyNIK() || this.getValue(this.getCheckBoxName())
    }


    render() {
        const {tab, errors} = this.props;

        return (
            <Fragment>
                <div style={{marginTop: "20px", marginBottom: "20px"}}>
                    <SimpleCheckBox
                        id={`input_check_box_${this.getCheckBoxName()}`}
                        key={this.getCheckBoxName()}
                        name={this.getCheckBoxName()}
                        label={this.getCheckBoxLabel()}
                        disabled={this.props.state.activityType === ACTIVITY_TYPE.UPDATE ? false : !this.props.state.isEditable}
                        checked={this.getValue(this.getCheckBoxName()) || this.state.isChecked}
                        onChange={({target}) =>
                            this.handleValueCheckBox(target.name, target.checked)
                        }
                    />
                </div>

                <div className="grid grid-2x gap-20px grid-mobile-none">
                    <div id="grid-1">
                        <FlexView vAlignContent="center" style={{justifyContent: "space-between"}}>
                            <SimpleInput
                                id="input_text_nama_pembeli"
                                containerclassname="width width-full"
                                name="name"
                                mandatory={this.getMandatoryField()}
                                label={this.getNamaPersonal()}
                                errorMessage={this.props.errors?.[tab]?.name}
                                value={this.getValue("name")}
                                onChange={({target}) => this.setValue(tab, target.name, target.value)}
                                readOnly={this.checkIsReadOnly()}
                            />
                            <SimpleButton
                                styles={{marginTop: 10, width: "auto"}}
                                disabled={this.checkIsReadOnly()}
                                icon={<i className='fa fa-md fa-search' />}
                                onClick={this.handleDetailCustomerVisible}
                            />
                        </FlexView>

                        <div>
                            <FlexView vAlignContent="center" style={{justifyContent: "space-between"}}>
                                <SimpleInput
                                    id="input_text_nik"
                                    containerclassname="width width-full"
                                    name="nik"
                                    label="NIK"
                                    box="onlyNumber"
                                    mandatory={this.getCheckMandatoryNIK()}
                                    errorMessage={this.props.errors?.[tab]?.nik}
                                    readOnly={this.setReadOnlyNIK()}
                                    value={this.getValue("nik")}
                                    onChange={({target}) => this.setValue(tab, target.name, target.value)}
                                />
                                <SimpleButton
                                    styles={{marginTop: 10, width: "auto"}}
                                    disabled={this.isCheckNIKDisabled()}
                                    text="CEK"
                                    onClick={this.handleCheckNIK}
                                />
                            </FlexView>
                        </div>

                        <SimpleInput
                            id="input_text_no_hp_1"
                            name="hpNumber1"
                            label="No HP 1"
                            box="onlyNumber"
                            mandatory={this.getMandatoryField()}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.hpNumber1}
                            value={this.getValue("hpNumber1")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_no_hp_2"
                            name="hpNumber2"
                            label="No HP 2"
                            box="onlyNumber"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("hpNumber2")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_email"
                            name="email"
                            label="Email"
                            mandatory={this.getMandatoryField()}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.email}
                            value={this.getValue("email")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleTextArea
                            id="input_text_alamat"
                            name="address"
                            label="Alamat"
                            mandatory={this.getMandatoryField()}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.address}
                            value={this.getValue("address")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_no_kk"
                            name="kkNumber"
                            label="No. KK"
                            box="onlyNumber"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("kkNumber")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_npwp"
                            name="npwp"
                            label="NPWP"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("npwp")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_province"
                            name="province"
                            label="Provinsi"
                            box="search"
                            mandatory={this.getMandatoryField()}
                            isClearable
                            options={this.state.provinceOptions}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.provinceId}
                            value={this.getValue("province")}
                            onChange={(value, {name}) => this.handleChangeProvince(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_city"
                            name="kabkot"
                            label="Kota"
                            box="search"
                            mandatory={this.getMandatoryField()}
                            isClearable
                            options={this.state.kotaOptions}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.kabkotId}
                            value={this.getValue("kabkot")}
                            onChange={(value, {name}) => this.handleChangeKota(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_district"
                            name="kecamatan"
                            label="Kecamatan"
                            box="search"
                            mandatory={this.getMandatoryField()}
                            isClearable
                            options={this.state.kecamatanOptions}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.kecamatanId}
                            value={this.getValue("kecamatan")}
                            onChange={(value, {name}) => this.handleChangeKecamatan(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_subdistrict"
                            name="kelurahan"
                            label="Kelurahan"
                            box="search"
                            mandatory={this.getMandatoryField()}
                            isClearable
                            options={this.state.kelurahanOptions}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.kelurahanId}
                            value={this.getValue("kelurahan")}
                            onChange={(value, {name}) => this.handleChangeKelurahan(name, value)}
                        />
                        <SimpleDDL
                            id="select_options_zipCode"
                            name="zipCode"
                            label="Kode Pos"
                            box="search"
                            isClearable
                            options={this.state.zipCodeOptions}
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("zipCode")}
                            onChange={(value, {name}) => this.setValue(tab, name, value)}
                        />
                        <SimpleDDL
                            id="select_options_jenis_kelamin"
                            name="gender"
                            label="Jenis Kelamin"
                            box="search"
                            mandatory={this.getMandatoryField()}
                            isClearable
                            options={this.state.genderOptions}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.gender || null}
                            value={this.getValue("gender")}
                            onChange={(value, {name}) => this.setValue(tab, name, value)}
                        />
                        <SimpleDDL
                            id="select_option_pekerjaan_1"
                            box="search"
                            name="job1"
                            label="Pekerjaan 1"
                            mandatory={this.getMandatoryField()}
                            options={this.state.jobOptions}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.job1}
                            value={this.getValue("job1")}
                            onChange={(value, {name}) => this.setValue(tab, name, value)}
                        />
                        <SimpleDDL
                            id="select_option_pekerjaan_2"
                            box="search"
                            name="job2"
                            label="Pekerjaan 2"
                            options={this.state.jobOptions}
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("job2")}
                            onChange={(value, {name}) => this.setValue(tab, name, value)}
                        />
                        <SimpleDDL
                            id="input_text_agama"
                            box="search"
                            name="religion"
                            label="Agama"
                            isClearable
                            mandatory={this.getMandatoryField()}
                            options={this.state.religionOptions}
                            readOnly={this.checkIsReadOnly()}
                            errorMessage={this.props.errors?.[tab]?.religion}
                            value={this.getValue("religion")}
                            onChange={(value, {name}) => this.setValue(tab, name, value)}
                        />
                    </div>
                    <div id="grid-2">
                        <div className="margin-5px">
                            <div className="txt-site txt-16 txt-main txt-bold">
                                <h4>Member Info</h4>
                            </div>
                        </div>
                        <SimpleInput
                            id="input_text_member_id"
                            name="memberId"
                            label="Member ID"
                            readOnly
                            value={this.getValue("memberId")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_member_lvl"
                            name="memberLevel"
                            label="Member Lvl"
                            readOnly
                            value={this.getValue("memberLevel")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_loyalty_lvl"
                            name="loyaltyLevel"
                            label="Loyalty Lvl"
                            readOnly
                            value={this.getValue("loyaltyLevel")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />

                        <div className="margin-5px margin-top-30px">
                            <div className="txt-site txt-16 txt-main txt-bold">
                                <h4>Social Media</h4>
                            </div>
                        </div>
                        <SimpleInput
                            id="input_text_facebook"
                            name="facebook"
                            label="Facebook"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("facebook")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_instagram"
                            name="instagram"
                            label="Instagram"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("instagram")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_linkedIn"
                            name="linkedin"
                            label="LinkedIn"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("linkedin")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_twitter"
                            name="x"
                            label="X (Twitter)"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("x")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleInput
                            id="input_text_tiktok"
                            name="tiktok"
                            label="Tiktok"
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("tiktok")}
                            onChange={({target}) => this.setValue(tab, target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_hobby"
                            name="hobby"
                            label="Hobby"
                            box="search"
                            isClearable
                            options={this.state.hobbyOptions}
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("hobby")}
                            onChange={(value, {name}) => this.setValue(tab, name, value)}
                        />
                        <SimpleDDL
                            id="select_options_interest"
                            name="interest"
                            label="Interest"
                            box="search"
                            isClearable
                            options={this.state.interestOptions}
                            readOnly={this.checkIsReadOnly()}
                            value={this.getValue("interest")}
                            onChange={(value, {name}) => this.setValue(tab, name, value)}
                        />
                    </div>
                </div>
                {this.state.detailCustomerVisible && (
                    <FakturJualDetailDataInput
                        {...this.props}
                        visible={this.state.detailCustomerVisible}
                        title="List Data Customer / Member"
                        type="Customer"
                        tableColumns={config.tableColumnDataCustomer}
                        onSelect={this.handleSelectCustomer}
                        onClickClose={this.handleDetailCustomerVisible}
                    />
                )}
                {this.state.isNIKNotfound && (
                    <SimpleAlert
                      visible={this.state.isNIKNotfound}
                      title={"Information"}
                      content={"NIK tidak terdaftar pada Database"}
                      onClickClose={() => {
                        this.setState((prev) => ({
                          ...prev,
                          isNIKNotfound: false,
                        }));
                      }}
                      additionalButtons={
                        <SimpleButton
                          type="button"
                          text="OK"
                          onClick={() => {
                            this.setState((prev) => ({
                              ...prev,
                              isNIKNotfound: false,
                            }));
                          }}
                        />
                      }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </Fragment>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(TabDataPersonal);